export default __webpack_public_path__ + "static/media/plans-image.8697ce51.png";